<template>
  <header id="kgu-header" ref="kguHeader" class="fixed-top">
    <div class="container">

      <div class="h-100">
        <router-link :to="'/'" class="logo-desktop d-none d-md-block">
          <img :src="logoFull" alt="Logo" title="zur Startseite">
        </router-link>
        <router-link :to="'/'" class="kgu-btn logo-mobile-small">
          <img :src="logoSmall" alt="Logo" title="zur Startseite">
        </router-link>
      </div>

      <ul class="header-nav nav">
        <li>
          <router-link :to="'/'" class="kgu-btn logo-mobile d-md-none ">
            <img :src="logoSmall" alt="Logo" title="zur Startseite">
          </router-link>
        </li>
        <li>
          <router-link :to="'/fachabteilungen'" class="kgu-btn">
            <span>
              <span class="d-none d-lg-inline">Medizinische&nbsp;</span>
              <span>Fachabteilungen</span>
            </span>
            <span class="phone-icon">
              <img :src="phone" alt="Fachabteilungen" title="Fachabteilungen" class="phone">
            </span>
          </router-link>
        </li>
        <li>
          <router-link :to="'/notfall'" class="kgu-btn emergency">
            <span>Notfall</span>
            <span class="cross-icon">
              <img :src="crossRed" alt="Notfall" title="Notfall" class="cross-red">
              <img :src="crossWhite" alt="Notfall" title="Notfall" class="cross-white">
            </span>
          </router-link>
        </li>

        <!--li class="menu-toggle">
          <button>
            <img :src="hamburger" alt="Menü" title="Menü">
          </button>
        </li-->
      </ul>

    </div>
  </header>
</template>

<script>
import LogoFull from '@/assets/ukf_logo.svg'
import LogoSmall from '@/assets/ukf.svg'
import Hamburger from '@/assets/hamburger.png'
import Phone from '@/assets/phone.svg'
import CrossRed from '@/assets/cross-red.png'
import CrossWhite from '@/assets/cross-white.png'

export default {
  name: 'KguHeader',

  data() {
    return {
      logoFull: LogoFull,
      logoSmall: LogoSmall,
      hamburger: Hamburger,
      phone: Phone,
      crossRed: CrossRed,
      crossWhite: CrossWhite,
    }
  },

  created() {
    window.addEventListener('scroll', () => {
      if (window.pageYOffset >= 100) {
        this.$refs.kguHeader.classList.add('shrink');
      } else if (window.pageYOffset <= 50) {
        this.$refs.kguHeader.classList.remove('shrink');
      }
    });

  },
}
</script>
